export default [
	{
		path: '/app/portfolios',
		name: 'portfolios.manage',
		component: () =>
			import(
				'../../../../../components/dashboard/back-office/portfolios/ManagePortfoliosComponent.vue'
			),
		meta: {
			allowedUsers: ['back-office']
		}
	},
	{
		path: '/app/portfolios/create',
		name: 'portfolios.create',
		component: () =>
			import(
				'../../../../../components/dashboard/back-office/portfolios/CreatePortfolioComponent.vue'
			),
		meta: {
			allowedUsers: ['back-office']
		}
	},
	{
		path: '/app/portfolios/:portfolio',
		name: 'portfolios.show',
		component: () =>
			import(
				'../../../../../components/dashboard/back-office/portfolios/ViewPortfolioComponent.vue'
			),
		meta: {
			allowedUsers: ['back-office']
		}
	}
];
